var render = function render(){var _vm=this,_c=_vm._self._c;return _c('avs-chip',{staticClass:"min-width-120",attrs:{"color":"error","icon":"mdi-alert-outline","iconColor":"blue","text-color":"blue"}},[_vm._v(" "+_vm._s(_vm.$t("commons.status.overdue"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }